import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class TermsAndConditionsLink extends Component {
  copy() {
    let copy = (
      <FormattedMessage
        id="termsAndConditionsLink.termsOfService"
        defaultMessage="Terms of Service"
      />
    );

    if (this.props.text) {
      copy = this.props.text;
    }

    return copy;
  }


  render() {
    if (!this.props.legalDocuments.length) return <span>{this.copy()}</span>;
    return (
      <span>
        <a
          href={`/purchases/${this.props.slug}/legal-documents`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.copy()}
        </a>
      </span>
    );
  }
}

TermsAndConditionsLink.defaultProps = {
  legalDocuments: [],
};

export default TermsAndConditionsLink;



// WEBPACK FOOTER //
// ./src/desktop/components/terms-and-conditions-link.js